import $ from 'jquery';
import { toggleButtonLoader } from '../utils/button-loader';
const ELEMENT_SELECTOR = '.js__form-submit-with-preview';
const PREVIEW_BUTTON_SELECTOR = '.js__preview-btn';
const PREVIEW_MODAL_SELECTOR = '.js__preview-modal';
const PREVIEW_ERROR_SELECTOR = '.js__preview-error';
export default class FormSubmitWithPreview {
    static init($root = $('body')) {
        const $forms = $root.find(ELEMENT_SELECTOR);
        if (!$forms.length) {
            return;
        }
        $forms.each((_, form) => {
            const $form = $(form);
            const $previewButton = $form.find(PREVIEW_BUTTON_SELECTOR);
            $previewButton.on('click', e => {
                e.preventDefault();
                const formAction = $form.data('preview-url');
                const formMethod = $form.attr('method') || 'POST';
                const formData = $form.serialize();
                const $error = $form.find(PREVIEW_ERROR_SELECTOR);
                const $modal = $(PREVIEW_MODAL_SELECTOR);
                $modal.find('.js__approve-btn').on('click', () => {
                    $modal.modal('hide');
                    $form.off('submit').submit();
                });
                $modal.find('.js__close-btn').on('click', () => {
                    $modal.modal('hide');
                });
                $.ajax({
                    url: formAction,
                    method: formMethod,
                    data: formData,
                    beforeSend() {
                        toggleButtonLoader($previewButton, true);
                        $error.hide();
                    },
                })
                    .done(response => {
                    if (!$modal.length) {
                        return;
                    }
                    $modal.find('.js__modal-content').html(response);
                    $modal.modal('show');
                    this.removeFormErrors($form);
                })
                    .fail(xhr => {
                    if (xhr.status === 422) {
                        $form.trigger('submit');
                    }
                    else {
                        $error.show();
                    }
                })
                    .always(() => {
                    toggleButtonLoader($previewButton, false);
                });
            });
        });
    }
    static removeFormErrors($form) {
        $form.find('.sylius-validation-error').remove();
        $form.find('.field').removeClass('error');
    }
}
